// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2JRWT","leftBlock":"style_leftBlock__oeXQt","avatar":"style_avatar__2GUcu","transcript":"style_transcript__1-iaF","footer":"style_footer__3RBp9"};